
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/word-forms-explanation';
const mainimage = '/Images/wordforms1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "wordforms" },
];

const WordForms = () => (
  <GrammarPageLayout
    level="B1"
    title="Word Forms"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Word Formation Exercises"
    seoDescription="Change word forms correctly: nouns, verbs, adjectives, adverbs. B2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default WordForms;

